import { DisplayPosition } from '@/common/manager/position/display-position';
import { CnBox, CnDownload, CnArrayTable as UICnArrayTable, } from '@cainiaofe/cn-ui';
import { calculateTextExprValue, confirmActionHoc, executeFunction, executeObjectExpr, getArrayTableCurrentRowByField2, getRealizeValue, getRunTimeItem, makeFormItemSchema, } from '@/common/util/util';
import get from 'lodash/get';
import { componentMap as filterItemComponentMap } from '../index';
import { getButtonAction } from '@/common/manager/button';
import { ButtonPosition } from '@/common/manager/position/button-position';
import { handleRequestParams, transRequestConfigToRemote, } from '@/common/util/request';
import { columnSuffix } from '@/common/util/const';
import $i18n from '@/locale-view/i18n';
import isEmpty from 'lodash/isEmpty';
import { __arrayTableCurrentRow__, __arrayTableCurrentRowByWhole__, __arrayTableCurrentRowIndex__, __arrayTableCurrentRowIndexByWhole__, __formValue__, __extraParam__, __stateValueOfSplit__, __dataSource__, __selectedRowKeys__, __selectedRowRecords__, } from '@/common/util/expr-const';
import set from 'lodash/set';
import isPlainObject from 'lodash/isPlainObject';
import { _getFormValues } from '@/common/util/biz-component-prop-name';
import React from 'react';
const add = 'add';
const remove = 'remove';
export const getDefaultButtons = () => {
    return [
        {
            children: $i18n.get({ id: 'AddARow', dm: '添加一行' }),
            optType: 'arrayTableAdd',
            primaryKey: add,
        },
        {
            primaryKey: remove,
            children: $i18n.get({ id: 'Delete', dm: '删除' }),
            optType: 'arrayTableRemove',
        },
    ];
};
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'CnArrayTable',
    formItemBeforeHandler: (formItem, config) => {
        const { formInstance, formItemConfig, formProps, isDesign, usedComponentList, urlParams, formValue, state, _context, } = config || {};
        const { _dataSourceName, formStyle = {} } = formProps || {};
        const { options } = formItemConfig || {};
        const { config: arrayTableFormConfig, buttons, footerButtons = [], headerButtons = [], style = {}, selection = {}, __advancedConfig__, } = options || {};
        if (formItem) {
            let isReadOnly = formStyle.readOnly
                ? executeObjectExpr(formStyle.readOnly, {
                    [__dataSource__]: state,
                    [__extraParam__]: {
                        openDialogMode: get(_context?.state?.valueOf, `${_dataSourceName}${__stateValueOfSplit__}openDialogMode`),
                    },
                }, formValue, state)
                : false;
            if (formItem) {
                if (typeof formItem['x-data']?.readOnly === 'boolean') {
                    isReadOnly = formItem['x-data'].readOnly;
                }
                if (typeof formItem.readOnly === 'boolean') {
                    isReadOnly = formItem.readOnly;
                }
            }
            formItem.type = 'array';
            let componentProps = {};
            if (!formItem['x-component-props']) {
                formItem['x-component-props'] = componentProps;
            }
            else {
                componentProps = formItem['x-component-props'];
            }
            if (componentProps) {
                componentProps.scroll = {
                    x: 0,
                };
                componentProps.onRow = (record, index) => {
                    return {
                        onClick: () => {
                            // 保证点击行的时候有数据
                            set(state, `valueOf.${_dataSourceName}.${formItemConfig?.name}.${__arrayTableCurrentRowByWhole__}`, record);
                            set(state, `valueOf.${_dataSourceName}.${formItemConfig?.name}.${__arrayTableCurrentRowIndexByWhole__}`, index);
                        },
                    };
                };
                const { pagination } = componentProps;
                if (typeof __advancedConfig__?.summary === 'function') {
                    componentProps.summary = (data) => {
                        return executeFunction(__advancedConfig__.summary, data, UICnArrayTable?.Summary, _context?.state);
                    };
                }
                formItem.items = {
                    type: 'object',
                    properties: {},
                };
                const { openSort, sortColumnWidth = 50 } = style;
                if (openSort) {
                    formItem.items.properties.__sortColumn__ = {
                        type: 'void',
                        'x-component': 'CnArrayTableColumn',
                        'x-component-props': {
                            width: sortColumnWidth,
                            title: $i18n.get({ id: 'Sort', dm: '排序' }),
                            align: 'center',
                        },
                        properties: {
                            sort: {
                                type: 'void',
                                'x-component': 'CnArrayTableSortHandle',
                            },
                        },
                    };
                }
                const { openSelect } = selection || {};
                let tempSelectedRowKeys = [];
                // let tempSelectedRowRecords: any[] = [];
                // 处理行选择功能
                if (openSelect && !isReadOnly) {
                    // // 更新选中状态的辅助函数
                    const updateSelectionState = (newKeys, newRows) => {
                        set(state, `valueOf.${_dataSourceName}.${formItemConfig?.name}.${__selectedRowKeys__}`, newKeys);
                        set(state, `valueOf.${_dataSourceName}.${formItemConfig?.name}.${__selectedRowRecords__}`, newRows);
                        tempSelectedRowKeys = newKeys;
                        console.log('selectedKeysFieldName', state?.valueOf?.[_dataSourceName]);
                    };
                    componentProps.rowSelection = {
                        selectedRowKeys: state?.valueOf?.[_dataSourceName]?.[formItemConfig?.name]?.[__selectedRowKeys__] || [],
                        onChange: (selectedRowKeys, selectedRows) => {
                            // 更新选中状态中的值
                            updateSelectionState(selectedRowKeys, selectedRows);
                        },
                    };
                }
                if (Array.isArray(arrayTableFormConfig) &&
                    arrayTableFormConfig.length > 0) {
                    const widthMap = {
                        RangeTimePicker: 204,
                        RangePicker: 308,
                    };
                    arrayTableFormConfig.forEach((item) => {
                        const { label, name, componentName, fixed } = item || {};
                        // 默认宽度 144px
                        let width = 144;
                        if (item.width || typeof item.width === 'number') {
                            width = item.width;
                        }
                        else if (!isReadOnly && widthMap[componentName]) {
                            width = widthMap[componentName];
                        }
                        if (name && componentName) {
                            const columnName = name + columnSuffix;
                            if (columnName) {
                                const columnTitle = calculateTextExprValue(label, {
                                    recordDataSource: {},
                                    state,
                                });
                                const columnFormItem = makeFormItemSchema({
                                    formItemConfig: item,
                                    isDesign,
                                    urlParams,
                                    formValue,
                                    state,
                                    usedComponentList,
                                    formProps,
                                    _context,
                                    formInstance,
                                });
                                const columnItem = {
                                    type: 'void',
                                    'x-component': 'CnArrayTableColumn',
                                    'x-component-props': { title: columnTitle, width, fixed },
                                    properties: {
                                        [name]: columnFormItem || {},
                                    },
                                };
                                if (item.hidden === true) {
                                    columnItem['x-hidden'] = true;
                                }
                                else if (item.hidden?.group === __formValue__) {
                                    // const formValueJudgeHidden = executeObjectExpr(item.hidden, {
                                    //   [__dataSource__]: _context?.state,
                                    //   [__formValue__]: formValue,
                                    // },formValue || {}, _context?.state, {})
                                    // if(formValueJudgeHidden === true) {
                                    //   columnItem['x-hidden'] = true;
                                    // }
                                } // if(columnFormItem && columnFormItem['x-hidden']) {
                                //   columnItem['x-hidden'] = true;
                                // }
                                // if(columnFormItem && columnFormItem['x-disabled']) {
                                //   columnItem['x-disabled'] = true;
                                // }
                                const componentDefine = getRunTimeItem(filterItemComponentMap, componentName);
                                if (componentDefine) {
                                    const tableColumnBeforeHandler = componentDefine?.tableColumnBeforeHandler;
                                    if (typeof tableColumnBeforeHandler === 'function') {
                                        tableColumnBeforeHandler({
                                            tableColumn: columnItem,
                                            formItem: columnFormItem,
                                        });
                                    }
                                }
                                formItem.items.properties[columnName] = columnItem;
                            }
                        }
                    });
                }
                // 处理按钮
                let realButtons = buttons;
                if (!buttons) {
                    realButtons = getDefaultButtons();
                }
                const optButtons = [];
                let addBtn;
                let importBtn;
                let exportBtn;
                realButtons?.forEach((item) => {
                    if (item.optType === 'arrayTableAdd') {
                        addBtn = item;
                    }
                    else {
                        optButtons.push(item);
                    }
                });
                footerButtons.forEach((item) => {
                    if (item.optType === 'ossImport') {
                        importBtn = item;
                    }
                    else if (item.optType === 'export') {
                        exportBtn = item;
                    }
                });
                // 推断是否所有按钮都是隐藏的
                // let judgeAllBtnHidden = true;
                // 只读状态下隐藏操作列
                const hiddenOperateColumn = style.hiddenOperateColumn && isReadOnly;
                if (optButtons?.length > 0 && !hiddenOperateColumn) {
                    // for(let item of optButtons) {
                    // const { hidden } = item || {}
                    // if(hidden?.group === __arrayTableCurrentRow__) {
                    //   judgeAllBtnHidden = false;
                    //   break;
                    // }
                    // const isHidden = executeObjectExpr(hidden, {
                    //   [__dataSource__]: _context?.state,
                    // },{}, _context?.state, {})
                    // if(isHidden !== true) {
                    //   judgeAllBtnHidden = false;
                    //   break;
                    // }
                    // }
                    const optProperties = {};
                    const { operateColumnWidth } = style;
                    const tempProps = {
                        title: $i18n.get({ id: 'ActionColumn', dm: '操作列' }),
                        lock: 'right',
                        fixed: 'right',
                    };
                    if (typeof operateColumnWidth === 'number') {
                        tempProps.width = `${operateColumnWidth}px`;
                    }
                    else {
                        tempProps.width = '100px';
                    }
                    formItem.items.properties.operateColumn = {
                        type: 'void',
                        'x-component': 'CnArrayTableColumn',
                        'x-component-props': tempProps,
                        properties: optProperties,
                    };
                    optButtons?.forEach((item) => {
                        const { children, optType, primaryKey, asyncLoading } = item || {};
                        if (optType && children && primaryKey) {
                            const action = getButtonAction({
                                ...item,
                                position: ButtonPosition.arrayTableOperate,
                            });
                            const temp = {
                                type: 'void',
                                title: '',
                            };
                            if (optType === 'arrayTableRemove' ||
                                optType === 'arrayTableMoveUp' ||
                                optType === 'arrayTableMoveDown') {
                                if (isReadOnly) {
                                    return;
                                }
                                temp['x-component'] = `Cn${optType.slice(0, 1).toUpperCase() + optType.slice(1)}`;
                            }
                            else {
                                temp['x-component'] = 'ArrayTableOptButton';
                                const componentDefine = getRunTimeItem({}, optType);
                                if (componentDefine?.component) {
                                    const _componentProps = {
                                        text: true,
                                    };
                                    temp['x-component-props'] = _componentProps;
                                    const component = getRealizeValue(componentDefine.component);
                                    if (component) {
                                        _componentProps.getChildren = () => {
                                            return React.createElement(component, {
                                                buttonConfig: item,
                                                position: ButtonPosition.arrayTableOperate,
                                                _context,
                                                [_getFormValues]: () => {
                                                    return formInstance?.values;
                                                },
                                            }, children);
                                        };
                                    }
                                }
                                else {
                                    const _componentProps = {
                                        children,
                                        text: true,
                                        type: 'primary',
                                        className: 'cn-ui-array-table-operate-btn',
                                        asyncLoading,
                                    };
                                    temp['x-component-props'] = _componentProps;
                                    if (action) {
                                        _componentProps.onClick = async (arg) => {
                                            let tempCurrentRow;
                                            let currentIndex;
                                            // 记录当前点击行数据
                                            if (arg?.field &&
                                                _dataSourceName &&
                                                _context?.state?.valueOf &&
                                                formItemConfig?.name) {
                                                tempCurrentRow = getArrayTableCurrentRowByField2(arg?.field);
                                                const segments = arg?.field?.path?.segments;
                                                if (isPlainObject(tempCurrentRow)) {
                                                    set(state, `valueOf.${_dataSourceName}.${formItemConfig.name}.${__arrayTableCurrentRow__}`, { ...tempCurrentRow });
                                                    currentIndex = segments?.[segments?.length - 2];
                                                    set(state, `valueOf.${_dataSourceName}.${formItemConfig.name}.${__arrayTableCurrentRowIndex__}`, currentIndex);
                                                }
                                                else {
                                                    let _currentIndex = segments?.[1];
                                                    if (_currentIndex !== 'number') {
                                                        _currentIndex = segments?.[segments?.length - 2];
                                                    }
                                                    if (typeof _currentIndex === 'number') {
                                                        const currentRow = arg?.field
                                                            ?.query('..')
                                                            ?.value?.()?.[_currentIndex];
                                                        if (isPlainObject(currentRow)) {
                                                            set(state, `valueOf.${_dataSourceName}.${formItemConfig.name}.${__arrayTableCurrentRow__}`, { ...currentRow });
                                                            set(state, `valueOf.${_dataSourceName}.${formItemConfig.name}.${__arrayTableCurrentRowIndex__}`, _currentIndex);
                                                        }
                                                    }
                                                }
                                            }
                                            const hocAction = confirmActionHoc({
                                                originalAction: action,
                                                item,
                                                _context,
                                                params: [
                                                    tempCurrentRow || {},
                                                    state,
                                                    currentIndex,
                                                    formInstance?.values,
                                                    formInstance,
                                                ],
                                            });
                                            return await hocAction({
                                                buttonConfig: item,
                                                position: ButtonPosition.arrayTableOperate,
                                                state,
                                                urlParamsDataSource: urlParams,
                                                _context,
                                                arrayTableConfig: config,
                                                field: arg?.field,
                                            }, arg);
                                        };
                                    }
                                }
                            }
                            optProperties[primaryKey] = temp;
                        }
                    });
                    if (isEmpty(optProperties)) {
                        delete formItem.items.properties.operateColumn;
                    }
                }
                formItem.properties = {};
                // 按照headerButtons中的顺序处理按钮
                headerButtons.forEach((headerBtn) => {
                    const { optType, primaryKey } = headerBtn;
                    if (optType === 'arrayTableBatchDelete' && !isReadOnly) {
                        let batchDeleteBtnProps; // TODO: 批量删除按钮内容
                        // 批量删除按钮内容
                        if (primaryKey) {
                            formItem.properties[primaryKey] = {
                                type: 'void',
                                'x-component': 'CnArrayTableBatchDelete',
                                data: {
                                    optType: 'arrayTableBatchDelete',
                                },
                            };
                        }
                        if (tempSelectedRowKeys.length > 0) {
                            batchDeleteBtnProps = {
                                selectedRowKeys: tempSelectedRowKeys,
                                onBatchDelete: (selectedRowKeys) => { },
                            };
                        }
                        if (batchDeleteBtnProps) {
                            formItem.properties[primaryKey]['x-component-props'] =
                                batchDeleteBtnProps;
                        }
                    }
                    if (optType === 'arrayTableClear' && !isReadOnly) {
                        let clearBtnProps; // TODO: 清空按钮内容
                        // 清空按钮内容
                        if (primaryKey) {
                            formItem.properties[primaryKey] = {
                                type: 'void',
                                'x-component': 'CnArrayTableClear',
                                data: {
                                    optType: 'arrayTableClear',
                                },
                            };
                        }
                        if (clearBtnProps) {
                            formItem.properties[primaryKey]['x-component-props'] =
                                clearBtnProps;
                        }
                    }
                });
                // 处理添加按钮（来自realButtons）
                if (!isReadOnly && addBtn) {
                    const { children, primaryKey } = addBtn;
                    if (primaryKey) {
                        let addBtnComponentProps;
                        const addBtnDefaultValue = addBtn?.options?.defaultValue;
                        if (Array.isArray(addBtnDefaultValue) &&
                            addBtnDefaultValue.length > 0) {
                            const temp = handleRequestParams(addBtnDefaultValue, {
                                recordDataSource: formValue,
                                state: _context?.state,
                            });
                            if (temp && Object.keys(temp).length > 0) {
                                addBtnComponentProps = {
                                    defaultValue: temp,
                                };
                            }
                        }
                        else if (typeof addBtnDefaultValue === 'function') {
                            addBtnComponentProps = {
                                defaultValue: addBtnDefaultValue.bind(this, {}, _context?.state),
                            };
                        }
                        formItem.properties[primaryKey] = {
                            type: 'void',
                            'x-component': 'CnArrayTableAddition',
                            title: children,
                        };
                        if (addBtnComponentProps) {
                            formItem.properties[primaryKey]['x-component-props'] =
                                addBtnComponentProps;
                        }
                    }
                }
                if ((!isReadOnly || isDesign) && importBtn) {
                    const { primaryKey } = importBtn;
                    if (primaryKey) {
                        const importOptions = importBtn.options || {};
                        const { handleProps } = importOptions;
                        let { headerSlot } = importOptions;
                        if (typeof headerSlot === 'function') {
                            headerSlot = executeFunction(headerSlot, _context?.state);
                        }
                        let ossImportProps = {
                            autoImport: true,
                            headerSlot,
                            uploadProps: {
                                requestConfig: transRequestConfigToRemote({
                                    requestConfig: importOptions.uploadService,
                                    needFormatResult: true,
                                }),
                            },
                            createRequestConfig: transRequestConfigToRemote({
                                requestConfig: importOptions.createService,
                                needFormatResult: true,
                            }),
                            pollingRequestConfig: transRequestConfigToRemote({
                                requestConfig: importOptions.pollingService,
                                needFormatResult: true,
                            }),
                        };
                        if (importOptions.templateUrl) {
                            const downloadProps = {};
                            if (typeof importOptions.templateUrl === 'string') {
                                downloadProps.url = importOptions.templateUrl;
                            }
                            else {
                                downloadProps.requestConfig = transRequestConfigToRemote({
                                    requestConfig: importOptions.templateUrl,
                                    needFormatResult: true,
                                });
                            }
                            ossImportProps.uploadMsgSlot = (<CnBox direction="row" align="center">
                  {$i18n.get({ id: 'PleaseDownload', dm: '请下载' })}&nbsp;
                  <CnDownload type="primary" text buttonText={$i18n.get({
                                    id: 'ImportFileTemplate',
                                    dm: '导入文件模板',
                                })} {...downloadProps}/>
                </CnBox>);
                        }
                        if (typeof handleProps === 'function') {
                            try {
                                const tempProps = handleProps(ossImportProps, _context?.state, (values) => {
                                    config
                                        .getFormInstance()
                                        ?.setValues(values(config.getFormInstance()?.values));
                                });
                                if (tempProps) {
                                    ossImportProps = { ...ossImportProps, ...tempProps };
                                }
                            }
                            catch (e) {
                                // 忽略用户执行的异常
                                console.error(e);
                            }
                        }
                        formItem.properties[primaryKey] = {
                            type: 'void',
                            'x-component': 'CnArrayTableImport',
                            'x-component-props': ossImportProps,
                        };
                    }
                }
                if ((isReadOnly || isDesign) && exportBtn) {
                    const { primaryKey } = exportBtn;
                    if (primaryKey) {
                        const exportOptions = exportBtn.options || {};
                        const { handleProps } = exportOptions;
                        const createRequestConfig = exportOptions.createRequestConfig ||
                            exportOptions.createService ||
                            {};
                        const pollingRequestConfig = exportOptions.pollingRequestConfig ||
                            exportOptions.pollingService ||
                            {};
                        const requestCommonParams = { recordDataSource: formValue, state };
                        let exportProps = {
                            createRequestConfig: transRequestConfigToRemote({
                                requestConfig: createRequestConfig,
                                needFormatResult: true,
                                formatParam: (() => {
                                    return function (data = {}) {
                                        const realParams = handleRequestParams(createRequestConfig.params, requestCommonParams);
                                        return { ...data, ...realParams };
                                    };
                                })(),
                                ...requestCommonParams,
                            }),
                            pollingRequestConfig: transRequestConfigToRemote({
                                requestConfig: pollingRequestConfig,
                                needFormatResult: true,
                                formatParam: (() => {
                                    return function (data = {}) {
                                        const realParams = handleRequestParams(pollingRequestConfig.params, requestCommonParams);
                                        return { ...data, ...realParams };
                                    };
                                })(),
                                ...requestCommonParams,
                            }),
                        };
                        if (typeof handleProps === 'function') {
                            try {
                                const tempProps = handleProps(exportProps, _context?.state);
                                if (tempProps) {
                                    exportProps = { ...exportProps, ...tempProps };
                                }
                            }
                            catch (e) {
                                // 忽略用户执行的异常
                                console.error(e);
                            }
                        }
                        formItem.properties[primaryKey] = {
                            type: 'void',
                            'x-component': 'CnArrayTableExport',
                            'x-component-props': exportProps,
                        };
                    }
                }
                if (pagination && formItem['x-component-props']) {
                    formItem['x-component-props'].pagination = pagination;
                }
                const additionButtonVisible = Object.values(formItem.properties).some((_item) => _item['x-component'] === 'CnArrayTableAddition');
                if (!formItem['x-component-props'].mobileProps) {
                    formItem['x-component-props'].mobileProps = {};
                }
                formItem['x-component-props'].mobileProps.additionButtonVisible =
                    additionButtonVisible;
                delete formItem?.['x-component-props']?.title;
            }
        }
    },
};
